import FormFechaTransaction from './FormFechaTransaction'

export default FormFechaTransaction
